import { MantineThemeOverride } from '@mantine/core';

export type AutocompleteTheme = NonNullable<MantineThemeOverride['components']>['Autocomplete'];

export const Autocomplete: AutocompleteTheme = {
  // todo: define
};
